import { desiredMediaState } from "./state";

const DB_NAME = "vcs-media";
const STORE = "customBackground";
const KEY = "image";

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function putBlob(blob: Blob): Promise<void> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readwrite");
        tx.objectStore(STORE).put(blob, KEY);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
      }),
  );
}

function getBlob(): Promise<Blob | null> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readonly");
        const req = tx.objectStore(STORE).get(KEY);
        req.onsuccess = () => resolve((req.result as Blob) || null);
        req.onerror = () => reject(req.error);
      }),
  );
}

function deleteBlob(): Promise<void> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readwrite");
        tx.objectStore(STORE).delete(KEY);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
      }),
  );
}

export async function saveCustomBackgroundImage(file: File | Blob): Promise<string> {
  await putBlob(file);
  return URL.createObjectURL(file);
}

export async function loadCustomBackground(): Promise<void> {
  try {
    const blob = await getBlob();
    if (blob) {
      desiredMediaState.customBackground = URL.createObjectURL(blob);
    }
  } catch {
    // ignore
  }
}

export async function clearCustomBackground(): Promise<void> {
  try {
    await deleteBlob();
  } catch {
    // ignore
  }
  if (desiredMediaState.customBackground) {
    URL.revokeObjectURL(desiredMediaState.customBackground);
    desiredMediaState.customBackground = null;
  }
}
